import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "thumb_down",
  "use": "thumb_down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"thumb_down\"><path d=\"M20.4 4h-3l-2-2H5.6L2 5.6v8.8L4.6 17H9v3.4l1.6 1.6h3.8l1.6-1.6v-3l1.4-1.4H22V5.6L20.4 4zM16 14.6l-2 2v3l-.4.4h-2.2l-.4-.4V15H5.4L4 13.6V12h5v-1H4V8h5V7H4v-.6L6.4 4h8.2L16 5.4v9.2zm4-.6h-2V6h1.6l.4.4V14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol